export default __webpack_public_path__ + "media/images/icons/shopping-cart-96a0532ed2b9f6e537a86768d3e5de99.svg";